// Public Google Form that James's daily review job already reads.
// Entry ids come from that form's published field list.
export const STARTUP_OFFER_FORM_ACTION =
  'https://docs.google.com/forms/d/e/1FAIpQLSfNhkwy7JTIZIPRQC7Crr4JFBCrs8NT8M2f-8g4Gf7EQ4H9cg/formResponse';

// Same dataLayer event SignupCard pushes after a trial account is created.
// GTM already listens for this name. The page path is /coco-startups, so a tag
// can limit itself to this page without a new event.
export const TRIAL_SIGNUP_CONVERSION_EVENT = 'self-service trial signup';

export const STARTUP_OFFER_AGREE_VALUE = 'Yes, I acknowledge and agree';

const ENTRY = {
  fullName: 'entry.1967507584',
  email: 'entry.631442323',
  website: 'entry.1846004184',
  plan: 'entry.1671309017',
  agree: 'entry.1546521216',
} as const;

export interface StartupApplicationInput {
  fullName: string;
  email: string;
  website: string;
  plan: string;
}

// The field is plain text, same as the Google Form. Add https:// when the
// user typed a host and left the scheme off.
export function normalizeWebsite(value: string): string {
  const website = value.trim();
  if (website === '' || /\s/.test(website)) {
    throw new Error('Enter a company website without spaces');
  }
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(website)) {
    return website;
  }
  return `https://${website}`;
}

export function buildStartupApplicationFields(
  input: StartupApplicationInput,
): Record<string, string> {
  return {
    [ENTRY.fullName]: input.fullName,
    [ENTRY.email]: input.email,
    [ENTRY.website]: normalizeWebsite(input.website),
    [ENTRY.plan]: input.plan,
    [ENTRY.agree]: STARTUP_OFFER_AGREE_VALUE,
    fvv: '1',
    pageHistory: '0',
  };
}

export function submitStartupApplication(fields: Record<string, string>, doc: Document): void {
  const frameName = 'startup-offer-submit';
  let frame = doc.getElementById(frameName) as HTMLIFrameElement | null;
  if (!frame) {
    frame = doc.createElement('iframe');
    frame.id = frameName;
    frame.name = frameName;
    frame.hidden = true;
    frame.setAttribute('aria-hidden', 'true');
    doc.body.appendChild(frame);
  }

  const form = doc.createElement('form');
  form.method = 'POST';
  form.action = STARTUP_OFFER_FORM_ACTION;
  form.target = frameName;
  form.acceptCharset = 'UTF-8';
  for (const [name, value] of Object.entries(fields)) {
    const input = doc.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }
  doc.body.appendChild(form);
  form.submit();
  form.remove();
}

export function recordTrialSignupConversion(layer: Array<{ event: string }>): void {
  layer.push({ event: TRIAL_SIGNUP_CONVERSION_EVENT });
}
